import PostTagList from '@/data/postTag/view/list.vue'

const list = {
  path: '/postTag',
  name: 'postTag-list',
  component: PostTagList
}

export default [list]
